/**
 * Reads the `exp` claim out of a JWT's payload without verifying its signature.
 * This is only ever used client-side as a hint to skip a network round trip we
 * already know will 401 - never to authorize anything, since an unverified
 * claim can't be trusted for that.
 */
export function getJwtExpiry(token: string): number | null {
  try {
    const payload = token.split('.')[1];
    if (!payload) return null;
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');
    const decoded = JSON.parse(atob(padded));
    return typeof decoded.exp === 'number' ? decoded.exp : null;
  } catch {
    return null;
  }
}

/** True only when the token decodes and its `exp` claim has passed. */
export function isJwtExpired(token: string): boolean {
  const exp = getJwtExpiry(token);
  return exp !== null && exp * 1000 <= Date.now();
}
